<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>


export default {
  name: 'app',
}
</script>

<style>
@font-face {
  font-family: 'AkiraExpanded';
  src: url('./assets/fonts/AkiraExpanded.otf') format('opentype');
}
@font-face {
  font-family: 'NewBlackTypeface';
  src: url('./assets/fonts/NewBlackTypeface-Regular.otf') format('opentype');
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: 'NewBlackTypeface';
  src: url('./assets/fonts/NewBlackTypeface-Medium.otf') format('opentype');
  font-weight: 500;
  font-style: normal;
}
@font-face {
  font-family: 'NewBlackTypeface';
  src: url('./assets/fonts/NewBlackTypeface-SemiBold.otf') format('opentype');
  font-weight: 600;
  font-style: normal;
}
@font-face {
  font-family: 'NewBlackTypeface';
  src: url('./assets/fonts/NewBlackTypeface-Bold.otf') format('opentype');
  font-weight: bold;
  font-style: normal;
}
@font-face {
  font-family: 'NewBlackTypeface';
  src: url('./assets/fonts/NewBlackTypeface-ExtraBold.otf') format('opentype');
  font-weight: 900;
  font-style: normal;
}
@font-face {
  font-family: 'TBJNoireAuthentic';
  src: url('./assets/fonts/TBJNoireAuthentic-Regular.otf') format('opentype');
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: 'TBJNoireAuthentic';
  src: url('./assets/fonts/TBJNoireAuthentic-Bold.otf') format('opentype');
  font-weight: bold;
  font-style: normal;
}
@font-face {
  font-family: 'TBJNoireAuthentic';
  src: url('./assets/fonts/TBJNoireAuthentic-Medium.otf') format('opentype');
  font-weight: 700;
  font-style: normal;
}
@font-face {
  font-family: 'TBJNoireAuthentic';
  src: url('./assets/fonts/TBJNoireAuthentic-Thin.otf') format('opentype');
  font-weight: 200;
  font-style: normal;
}
:root {
  --form-floating-height: 3.5rem;
  --form-floating-line-height: 1.25;
  --form-floating-padding-y: 1rem;
  --form-floating-padding-x: 0.75rem;
  --form-floating-input-padding-t: 1.625rem;
  --form-floating-input-padding-b: 0.625rem;
  --form-floating-label-opacity: 0.65;
  --form-floating-label-transform: scale(.85) translateY(-0.5rem) translateX(0.15rem);
  --form-floating-label-height: 1.5em;
  --form-floating-transition: opacity .1s ease-in-out, transform .1s ease-in-out;
  --input-border-width: 1px;
  --input-border-radius: 0.375rem;
  --input-bg: #fff;
  --input-disabled-bg: #e9ecef;
  --form-floating-label-disabled-color: #6c757d;
  --body-color-rgb: 33, 37, 41;
}


html, body {
  scroll-behavior: smooth;
}

#app {
  font-family: 'NewBlackTypeface', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #000;
  scroll-behavior: smooth;
}

.sectioncurso ::marker {
  color: #2CFAC3;
}
.btn{
  outline: 0 !important;
  box-shadow: none !important;
}
.slick-track
{
    display: flex !important;
}

.slick-slide
{
    height: inherit !important;
}
.slick-slide div {
  height: 100% !important;
}
.slick-dots li.slick-active button:before{
    color: #2CFAC3 !important;
}
.slick-dots li,li{
    margin-top: 20px;
  }
.slick-dots li button:before{
    color: white!important;
    opacity: 1 !important;
    font-size: 15px !important;
  }

  .player{
    width: 100%;
    height: auto; 
    aspect-ratio: 9/16;
  }

  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-internal-autofill-selected {
    box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0), inset 0 0 0 100px rgba(255, 255, 255,1);
    -webkit-box-shadow: 0 0 50px rgba(255, 255, 255, 0) inset !important;
    background-color: transparent !important;
    background-clip: text;
    transition: background-color 0s 600000s, color 0s 600000s !important;
}
</style>
